"use client";

import React from "react";
import { Utensils, MapPin, Smartphone, Search, Image as ImageIcon, Zap } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";

/**
 * GastronomyWebsite — Section 4: 6 Branchen-Features
 * Drop-in für: src/pages/GastronomyWebsite/sections/TailoredForEveryDepartment.tsx
 *
 * 3x2-Grid mit gastro-spezifischen Features. Jede Card mit Icon, Titel, Beschreibung.
 */

const features = [{
  icon: Utensils,
  title: "Digitale Speisekarte",
  description: "Ihre Speisekarte online — übersichtlich, mobilfreundlich und jederzeit selbst aktualisierbar. Nie wieder PDF-Uploads."
}, {
  icon: MapPin,
  title: "Google Maps Integration",
  description: "Ihre Gäste finden Sie sofort — mit eingebetteter Karte, Adresse und Wegbeschreibung direkt auf der Website."
}, {
  icon: Smartphone,
  title: "Mobilfreundlich",
  description: "80 % Ihrer Gäste suchen auf dem Handy. Ihre Website sieht auf jedem Gerät perfekt aus — automatisch."
}, {
  icon: Search,
  title: "Google-Optimierung (SEO)",
  description: 'Gefunden werden, wenn jemand „Restaurant in [Ihre Stadt]" sucht. Die KI optimiert Texte und Metadaten automatisch.'
}, {
  icon: ImageIcon,
  title: "Fotogalerie",
  description: "Zeigen Sie Ihr Ambiente, Ihre Gerichte und Ihr Team. Professionelle Bildergalerie inklusive — einfach per Drag & Drop."
}, {
  icon: Zap,
  title: "Blitzschnell",
  description: "Dank Google Cloud und Cloudflare CDN lädt Ihre Website in unter 1 Sekunde. Kein Gast springt mehr ab."
}];
export default function TailoredForEveryDepartment() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section className="bg-background py-20 md:py-24">
      <div ref={ref} className={`max-w-7xl mx-auto px-4 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center max-w-3xl mx-auto mb-14 md:mb-16">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-foreground mb-4 leading-tight">
            Alles, was Ihr Restaurant online braucht
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground">
            Speziell für die Gastronomie entwickelt.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((f, i) => <div key={i} className="group bg-card border border-border rounded-xl p-7 hover:border-primary/40 hover:shadow-xl transition-all duration-300">
              <div className="mb-5 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10 text-primary group-hover:bg-primary group-hover:text-white transition-colors">
                <f.icon className="w-6 h-6" strokeWidth={1.5} />
              </div>
              <h3 className="text-xl font-bold text-foreground mb-2 tracking-tight">
                {f.title}
              </h3>
              <p className="text-base leading-relaxed text-muted-foreground">
                {f.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}